<template>
  <q-card
    flat
    bordered
    class="col-12 border-radius-4 border-box q-mr-sm"
    style="max-width: 150px"
  >
    <q-card-section
      horizontal
      class="items-center justify-around handle"
    >
      <q-circular-progress
        v-if="attach.uploading"
        show-value
        font-size="14px"
        indeterminate
        size="45px"
        :thickness="0.10"
        color="primary"
        track-color="grey-3"
      >
        {{ attach.progress }}%
      </q-circular-progress>

      <q-img
        basic
        v-else-if="isImage"
        :src="attach.url"
        spinner-color="primary"
        class="col"
        style="height: 53px"
        v-img="{ title: attachName, src: attach.url }"
      >
        <q-tooltip>
          {{ attachName }}
        </q-tooltip>

        <template #loading>
          <q-spinner-ios color="primary" />
        </template>
      </q-img>

      <div
        v-else
        class="col"
      >
        <div class="row">
          <div
            :class="['col-auto q-mx-auto q-py-sm', isAudio ? '' : 'cursor-pointer' ]"
            data-testid="anexo-abrir"
            @click="() => isPDF ? showPDF() : downloadField()"
          >
            <PdfIcon
              style="max-height: 60px"
              v-if="isPDF"
            />

            <WordIcon
              style="max-height: 60px"
              v-if="isWord"
            />

            <ExcelIcon
              style="max-height: 60px"
              v-if="isExcel"
            />

            <Aplayer
              mini
              v-if="isAudio"
              :music="{
                title: attachName,
                src: attach.url
              }"
            />

            <GenericIcon
              style="max-height: 60px"
              v-if="isGeneric"
            />

            <PowerPointIcon
              style="max-height: 60px"
              v-if="isPowerPoint"
            />

            <q-tooltip>
              {{ attachName }}
            </q-tooltip>
          </div>
        </div>
      </div>
    </q-card-section>

    <q-separator />

    <q-card-section
      class="q-py-xs q-px-none"
      style="font-size: 12px"
    >
      <q-card-actions
        vertical
        class="col-auto q-pa-none"
      >
        <div class="row full-width no-wrap items-center">
          <q-btn
            flat
            unelevated
            size="xs"
            padding="0"
            color="negative"
            class="col-auto"
            data-testid="anexo-remover"
            @click="$emit('on-remove')"
            v-if="!readonly"
            icon="mdi-close"
          >
            <q-tooltip>Remover Anexo</q-tooltip>
          </q-btn>

          <div
            class="col ellipsis q-px-xs cursor-pointer"
            data-testid="anexo-baixar"
            @click="downloadField"
          >
            <small>
              {{ attachName }}
              <q-tooltip>Baixar</q-tooltip>
            </small>
          </div>

          <q-checkbox
            data-testid="anexo-selecionar"
            dense
            v-if="showCheckbox"
            v-model="checked"
            color="primary"
            checked-icon="mdi-check-decagram"
            unchecked-icon="mdi-checkbox-blank-circle-outline"
          >
            <q-tooltip>{{ descCheckbox }}</q-tooltip>
          </q-checkbox>
        </div>
      </q-card-actions>
    </q-card-section>
  </q-card>
</template>

<script>
import PdfIcon from '@/assets/icons/PdfIcon.svg'
import WordIcon from '@/assets/icons/WordIcon.svg'
import ExcelIcon from '@/assets/icons/ExcelIcon.svg'
import GenericIcon from '@/assets/icons/GenericIcon.svg'
import PowerPointIcon from '@/assets/icons/PowerPointIcon.svg'
import ModalPDF from './ModalPDF.vue'
import Aplayer from 'vue-aplayer'
import { download } from '@/components/player/utils.js'

export default {
  components: {
    PdfIcon,
    Aplayer,
    WordIcon,
    ExcelIcon,
    GenericIcon,
    PowerPointIcon
  },

  props: {
    attach: {},

    isChecked: {
      type: Boolean,
      default: false
    },

    showCheckbox: {
      type: Boolean,
      default: false
    },

    descCheckbox: {
      type: String,
      default: ''
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    const checked = Boolean(this.isChecked)
    return { checked }
  },

  methods: {
    downloadField () {
      if (this.isPDF) return this.$q.dialog({ component: ModalPDF, parent: this, url: this.attach.url })
      if (this.isImage) return
      if (this.isAudio) return
      download(this.attach.url, this.attach.name)
    },

    showPDF () {
      if (this.isPDF) return this.$q.dialog({ component: ModalPDF, parent: this, url: this.attach.url })
    }
  },

  computed: {
    attachName () {
      return String(this.attach?.name || '').trim()
    },

    isZip () {
      return isMime(this.attach, ['zip', 'rar'])
    },

    isPDF () {
      return isMime(this.attach, ['pdf'])
    },

    isWord () {
      return isMime(this.attach, ['word'])
    },

    isExcel () {
      return isMime(this.attach, ['spread', 'sheet', 'excel'])
    },

    isAudio () {
      return isMime(this.attach, ['audio'])
    },

    isImage () {
      return isMime(this.attach, ['image'])
    },

    isPowerPoint () {
      return isMime(this.attach, ['presentation'])
    },

    isGeneric () {
      return !this.isPDF && !this.isWord && !this.isExcel && !this.isPowerPoint && !this.isAudio
    }
  },

  watch: {
    checked: {
      deep: true,
      handler (checked) {
        if (Boolean(this.isChecked) === Boolean(checked)) return
        this.$emit('check', Boolean(checked))
      }
    },

    isChecked: {
      deep: true,
      handler (isChecked) {
        if (Boolean(this.checked) === Boolean(isChecked)) return
        this.checked = Boolean(isChecked)
      }
    }
  }
}

const lowerStr = (val) => String(val || '').trim().toLowerCase()

const isMime = (attach, mimes) => {
  const attachMime = lowerStr(attach?.mime)
  return Boolean(mimes.find((mime) => attachMime.includes(lowerStr(mime))))
}

</script>

<style lang="sass">
  .link-download-readonly
    position: absolute
    right: 0
    top: 0
</style>
